import { authenticatedApiFetch } from '../utils/utils'

export const allSubjectsService = async () => {
    const res = await authenticatedApiFetch(`/subjects/`)
		.then(response => response.json())
		.catch(error => console.error(error))
	return res
}
